export const isSuspendedFrom = (userSnapShotServerRes) => {
  try {
    const r = userSnapShotServerRes?.response || userSnapShotServerRes || {};
    const data = r?.data || {};
    // ✅ Only eject on explicit, domain-level suspension signals
    if (
      data?.memberStatus === "suspended" ||
      data?.code === "SUSPENDED" ||
      data?.event?.type === "eject"
    ) {
      return true;
    }
    // (Optional) If you still want to allow 401/403 to count,
    // do it ONLY when the payload says it's due to suspension.
    if (
      (r.status === 401 || r.status === 403) &&
      (data?.reason === "suspended" || data?.code === "SUSPENDED")
    ) {
      return true;
    }
    return false;
  } catch {
    return false;
  }
};
